import React, { useContext, createContext, useState } from "react";
import { Movies } from "../screen components/Data/MovieData";

// creating creatContext hook for easy accessible of its properties across the various "valuecomponents
const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [cart, setCart] = useState([]);

  const handleFilter = (data) => {
    const newCart = Movies.filter((movie) => movie.id === data);
    const [{ id, name, image }] = newCart;
    setCart([...cart, { id, name, image }]);
  };

  const handleDelete = (data) => {
    const newCart = cart.filter((movie) => movie.id !== data);
    setCart(newCart);
  };

  return (
    <AuthContext.Provider
      value={{ show, setShow, cart, setCart, handleDelete, handleFilter }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default function useAuthContext() {
  return useContext(AuthContext);
}
